import bemBlock from '@gik/core/utils/bemBlock';
import classnames from 'classnames';
import type { CSSProperties } from 'react';
import React from 'react';

export interface ILayoutAsideProps extends React.HTMLAttributes<HTMLDivElement> {
  asideWidth?: string;
  gutter?: string;
  breakpoint?: string;
  elementQueries?: boolean;
}

export function LayoutAside({
  children,
  asideWidth,
  gutter,
  breakpoint,
  elementQueries,
  className,
  id,
}: ILayoutAsideProps): React.ReactElement {
  const bem = bemBlock(elementQueries ? 'layout-aside-eq' : 'layout-aside');
  const blockClasses = classnames([bem(), className || '']);
  const otherProps: Partial<ILayoutAsideProps> = {};
  if (elementQueries) {
    otherProps.style = {
      '--aside-width': asideWidth,
      '--gutter': gutter,
      '--breakpoint': breakpoint,
    } as CSSProperties;
  } else {
    otherProps.style = {
      '--aside-width': asideWidth,
      '--gutter': gutter,
    } as CSSProperties;
  }
  return (
    <div className={blockClasses} id={id} {...otherProps}>
      {children}
    </div>
  );
}
